import { Component, OnInit, ElementRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit {
    public avatarImage: string = '';
    public username: string = '';
    constructor(
        private authService: AuthService,
        private elRef: ElementRef
    ) { }

    ngOnInit() {
        this.username = this.authService.getUsername();
        document.getElementById('myavatarImage')?.setAttribute('xlink:href', this.authService.getAvatarImage());
        const userEl = document.getElementById('avatarUsername');
        if (userEl) {
          userEl.innerHTML =  this.authService.getUsername();
        }
    }
}
